import * as React from "react";
const SvgFiRrMortarPestle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-mortar-pestle_svg__a)">
      <path
        fill="#062147"
        d="M21 9h-1.683l3.657-3.025A3.48 3.48 0 0 0 24 3.5c0-.935-.364-1.814-1.025-2.475-1.322-1.322-3.563-1.393-5.013.07l-6.53 7.904h-8.43a2.97 2.97 0 0 0-2.34 1.128 3.04 3.04 0 0 0-.578 2.59c.63 2.708 2.462 5.296 5.03 7.1.402.233.887.853.887 1.182 0 .551-.448 1-1 1a1 1 0 0 0 0 2h14a1 1 0 1 0 0-2 1 1 0 0 1-1-1c0-.329.484-.949.888-1.182 2.567-1.804 4.4-4.392 5.03-7.101a3.03 3.03 0 0 0-.579-2.589A2.97 2.97 0 0 0 21 8.999zm-1.56-6.561A1.502 1.502 0 0 1 22 3.499c0 .4-.157.777-.37.997l-5.45 4.503h-2.157zM16.171 22H7.828c.111-.313.172-.649.172-1 0-.341-.075-.679-.202-1h8.405a2.7 2.7 0 0 0-.202 1c0 .351.06.687.171 1m5.798-9.735c-.5 2.148-1.943 4.223-3.98 5.735H6.011c-2.037-1.512-3.48-3.587-3.98-5.734a1.05 1.05 0 0 1 .196-.893A.97.97 0 0 1 3 11h18a.97.97 0 0 1 .773.373c.198.25.27.575.196.893z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-mortar-pestle_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMortarPestle;
